import React, { useEffect, useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import classes from './CardWithToggle.module.scss';
import { ToggleSwitch } from '../../../ToggleSwitch/ToggleSwitch';
import { alertShowMore, alertShowLess } from '../../../../../utils/constants';

const CardWithToggle = (props) => {
  const {
    title,
    subtitle,
    details,
    slicedVal,
    extraComponent,
    handleShowMoreClick,
    dataList,
    status,
    onToggleChange,
    cardStyleFade
  } = props;
  const [toggleState, setToggleState] = useState(status);
  const [isOnline, setIsOnline] = useState(true);

  const handleToggleChange = () => {
    if (isOnline) {
      setToggleState(!toggleState);
      if (onToggleChange) onToggleChange(!toggleState);
    }
  };

  useEffect(() => {
    setToggleState(status);
  }, [status]);

  useEffect(() => {
    const updateOnlineStatus = () => {
      setIsOnline(navigator.onLine);
    };

    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);

    return () => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
    };
  }, []);

  return (
    <div className={classes.listContainer}>
      <div className={classes.outerContainer}>
        <div className={cardStyleFade ? classes.innerContainerfade : classes.innerContainer}>
          <h4>{title}</h4>
          <div className={cardStyleFade ? classes.toggleSwitchDisable : classes.toggleSwitchEnable}>
            <ToggleSwitch
              checked={toggleState}
              onChange={handleToggleChange}
              customTrackColor={cardStyleFade ? '#D1D3D4' : null}
            />
          </div>
          <p>{subtitle}</p>
        </div>
        {toggleState && (
          <div className={classes.detailContainer}>
            {details}
            {extraComponent && dataList?.length > 2 && slicedVal === alertShowLess && (
              <div className={classes.showmore}>
                <span role="presentation" onClick={() => handleShowMoreClick(alertShowMore)}>
                  Show more <KeyboardArrowDownIcon />
                </span>
              </div>
            )}
            {extraComponent && dataList?.length > 2 && slicedVal === alertShowMore && (
              <div className={classes.showmore}>
                <span role="presentation" onClick={() => handleShowMoreClick(alertShowLess)}>
                  Show less <KeyboardArrowUpIcon />
                </span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CardWithToggle;
